import { createSlice } from "@reduxjs/toolkit";
import { ISelectOption } from "src/@types/form";
import { getCloneTypesReducer } from "./reducers";
import { CLONE_TYPES_SLICE_NAME } from "./actions";

export interface ICloneTypesState {
  cloneTypes: {
    isLoading: boolean;
    items: ISelectOption[];
  };
}

const initialState: ICloneTypesState = {
  cloneTypes: {
    isLoading: false,
    items: [],
  },
};

export const { reducer: cloneTypes } = createSlice({
  name: CLONE_TYPES_SLICE_NAME,
  initialState,
  reducers: {},
  extraReducers(builder) {
    getCloneTypesReducer(builder);
  },
});
